import React from "react";

const PaymentSuccess = ({ operator, plan, mob, zero }) => {
  return (
    <div className="plan-summary-details">
      <div className="plan-header">
        <div className="d-flex align-center gap1">
          <div className="plan-logo">
            <img src={operator?.icon} alt="Jio Logo" />
          </div>
          <div className="plan-info">
            <h4>{operator?.label}</h4>
            <p>+91 {mob} | 11:42AM - March 12, 2025</p>
          </div>
          <div className="amount">₹ {plan?.price}</div>
        </div>
      </div>
      <br />
      <h4>Payment Details</h4>
      <div>
        <p className="success-msg">
          Thank you for choosing Zenus Bank. Your Mobile Recharge of ₹{" "}
          {plan?.price} has been successful.
        </p>

        <div className="transaction-info">
          <div>
            <p className="label">Transaction ID</p>
            <p>23456789087</p>
          </div>
          <div>
            <p className="label">BBPS Reference ID</p>
            <p>BUVIEY473643547</p>
          </div>
          <div>
            <p className="label">Debited from</p>
            <p>jeevankumar@ybl - UPI</p>
          </div>
        </div>
        <br />
        <br />
        {/* Buttons */}
        <div className="button-group">
          <button className="back-btn" type="button" onClick={zero}>
            View Transaction History
          </button>
          <button className="send-btn ml2" type="button" onClick={zero}>
            Download Receipt
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
